<template>
    <div>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>

        <InputRadioGroup
            name="currently_in_education"
            :required="isRequired('currently_in_education')"
            :error="form.errors.get('currently_in_education')"
            v-model="form.currently_in_education"
            :options="getField('currently_in_education').options"
            @input="form.errors.clear('currently_in_education')"
        >
            <template v-slot:question>
                {{ getField("currently_in_education").question }}
            </template>
        </InputRadioGroup>

        <InputNumber
            v-if="form.currently_in_education == 'yes'"
            name="average_education_hours"
            :required=true
            :error="form.errors.get('average_education_hours')"
            v-model="form.average_education_hours"
        >
            <template v-slot:question>
                {{ getField("average_education_hours").question }}
            </template>
            <template v-slot:description>
                {{ getField("average_education_hours").description }}
            </template>
        </InputNumber>

        <InputYearsMonths
            v-if="form.currently_in_education == 'no'"
            name="since_last_education"
            :required="isRequired('since_last_education_years')"
            :error="
                form.errors.get('since_last_education_months') ||
                form.errors.get('since_last_education_years')
            "
            :years="form.since_last_education_years"
            @years-updated="form.since_last_education_years = $event"
            :months="form.since_last_education_months"
            @months-updated="form.since_last_education_months = $event"
        >
            <template v-slot:question>
                {{ getField("since_last_education_months").question }}
            </template>
            <template v-slot:description>
                {{ getField("since_last_education_months").description }}
            </template>
        </InputYearsMonths>
    </div>
</template>

<script>
import InputNumber from "../Form/InputNumber";
import InputRadioGroup from "../Form/InputRadioGroup";
import InputYearsMonths from "../Form/InputYearsMonths";
import Form from "../../Form";
import { isRequired } from "./formHelper.js";

export default {
    name: "StepEducation",
    components: {
        InputRadioGroup,
        InputNumber,
        InputYearsMonths,
    },
    methods: {
        getField(fieldName) {
            return this.fields[fieldName];
        },
        isRequired(fieldName) {
            var fieldData = this.getField(fieldName);
            return isRequired(fieldData, this.form);
        },
    },
    data: function () {
        return {
            form: new Form({
                currently_in_education: null,
                average_education_hours: null,
                since_last_education_months: null,
                since_last_education_years: null,
            }, this.formData),
        };
    },
    props: {
        step: Object,
        fields: Object,
        formData: Object,
    },
};
</script>